import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, DatePipe } from '@angular/common';
import { NgModule, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { SecurityModule } from '@features/security';
import {
  CategoriesTooltipComponent,
  ConnectorStatusInfoComponent,
  DataSourceApprovalStatusInfoComponent,
  DataSourceConectStatusInfoComponent,
  DeviderComponent,
  DialogCloseButtonComponent,
  DistributionHealthInfoComponent,
  ErrorPageContentComponent,
  FieldErrorsMessagesComponent,
  HeaderComponent,
  InfoCardComponent,
  MenuComponent,
  PipelineStatusInfoComponent,
  ProjectsStatusInfoComponent,
  SupportLinksPanelComponent,
  ToolsPanelComponent,
} from './components';
import {
  BlurOnReleaseDirective,
  CategoriesToolTipDirective,
  IsOverflowFieldDirective,
  StepperDisableLastStep,
  StopPropagationActionDirective,
  StopPropagationScrollDirective,
  TableScrollRememberDirective,
} from './directives';
import {
  DateFormatPipe,
  DurationPipe,
  IsTextTruncatedPipe,
  ServerStringConverterPipe,
  StatusColorPipe,
  StringifyObjectPipe,
} from './pipes';

const matModules = [
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatSelectModule,
  MatTableModule,
  MatTabsModule,
  MatSortModule,
  MatToolbarModule,
  MatMenuModule,
  MatProgressBarModule,
  MatPaginatorModule,
  MatTooltipModule,
  MatSidenavModule,
  MatListModule,
  MatSlideToggleModule,
  MatRadioModule,
  MatButtonToggleModule,
  MatExpansionModule,
  MatSnackBarModule,
  MatStepperModule,
  MatProgressSpinnerModule,
];

const components: Type<any>[] = [
  DialogCloseButtonComponent,
  FieldErrorsMessagesComponent,
  DeviderComponent,
  InfoCardComponent,
  MenuComponent,
  HeaderComponent,
  ToolsPanelComponent,
  ErrorPageContentComponent,
  SupportLinksPanelComponent,
  PipelineStatusInfoComponent,
  ProjectsStatusInfoComponent,
  ConnectorStatusInfoComponent,
  DataSourceApprovalStatusInfoComponent,
  DataSourceConectStatusInfoComponent,
  DistributionHealthInfoComponent,
  CategoriesTooltipComponent,
];
const directives: Type<any>[] = [
  StopPropagationActionDirective,
  StepperDisableLastStep,
  StopPropagationScrollDirective,
  IsOverflowFieldDirective,
  TableScrollRememberDirective,
  CategoriesToolTipDirective,
  BlurOnReleaseDirective,
];
const pipes: Type<any>[] = [
  StatusColorPipe,
  DateFormatPipe,
  DurationPipe,
  ServerStringConverterPipe,
  StringifyObjectPipe,
  IsTextTruncatedPipe,
];

@NgModule({
  declarations: [...components, ...directives, ...pipes, CategoriesTooltipComponent],
  imports: [CommonModule, OverlayModule, SecurityModule.forChild(), RouterModule, ...matModules, ReactiveFormsModule],
  exports: [...matModules, OverlayModule, ...components, ...directives, ...pipes],
  providers: [DatePipe],
})
export class SharedModule {}
